/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { PointDtoModel } from './point-dto.model';

export class DelAddressDtoModel extends JSONable {
  uuid: string | null | undefined = null;

  owner: string | null = null;

  addressLine: string | null = null;

  city: string | null = null;

  state: string | null = null;

  postalCode: string | null = null;

  country: string | null = null;

  pointDTO: PointDtoModel | null | undefined= null;

  deleted: boolean | null = null;

  version: number | null = null;

  addressLabel: string | null = null;

  addressOriginType: string | null = null;

  transient: string | null = null;

  streetName?: string | null = null;

  block?: string | null = null;
  building?: string | null = null;
  floor?: string | null = null;
  apartment?: string | null = null;
  cityCode?: string | null = null;
  countyCode?: string | null = null;
  details?: string | null = null;

  partial?: boolean | null = null;

  streetNumber?: string | null = null;

  basedOnAddressTemplateUuid: string | null = null;
}
